// Engraving add-on: link main + add-on with FEI-XXXXXX per *Add to Cart* click
(() => {

    const ROOT_SELECTOR = '#MainContent';

    const radiosSelector   = `${ROOT_SELECTOR} input[type="radio"][name="properties[_Gravur_hinzufügen]"]`;
    const sideSelector     = `${ROOT_SELECTOR} [name="properties[gravurseite]"]`;
    const qtyInputSelector = `${ROOT_SELECTOR} quantity-component input[type="number"][name="quantity"]`;

    const PRODUCT_1 = '51277123486043'; // vorderseite || rückseite || Oberseite || Innenseite
    const PRODUCT_2   = '51277122535771'; // beidseitig
    const PRODUCT_3   = '51277128335707'; // Lasergravur seitlich am Gehäuse
    const PRODUCT_4   = '51277129580891'; // Beidseitig-Siegelring
    const PRODUCT_5   = '51760069771611'; // Ringgravur
    const PRODUCT_6   = '52840737112411'; // Einseitig (Vorne oder hinten)

    
    const FORM_IDX_DATA_KEY = 'gravurItemsIndex';
    const DATA_FLAG = 'data-gravur-extra';
    const MAIN_ENGRAVE_PROP = 'properties[EngraveID]';

    // --- helpers & scopes ------------------------------------------------------
    const getRoot = () => document.querySelector(ROOT_SELECTOR) || document;
    const getContainer = () => getRoot().querySelector('product-content') || null;
    const findFormAfterQuantityWrap = () => {
        const root = getRoot();
        const quantityWrap = root.querySelector('.product-quantity__wrap');
        if (!quantityWrap) {
            return null;
        }

        let sibling = quantityWrap.nextElementSibling;
        let index = 0;
        while (sibling) {
            index += 1;
            const form = sibling.querySelector?.('form[action*="/cart/add"]');
            if (form) return form;
            sibling = sibling.nextElementSibling;
        }
        return null;
    };
    const getATCForm = () => {
        const formFromQuantityWrap = findFormAfterQuantityWrap();
        if (formFromQuantityWrap) {
            return formFromQuantityWrap;
        }

        const c = getContainer();
        if (!c) {
            return null;
        }
        const forms = c.querySelectorAll('form[action*="/cart/add"]');
        const form = forms.length ? forms[0] : null;
        return form;
    };

    const makeEngraveId = () => `FEI-${Math.floor(100000 + Math.random() * 900000)}`; // FEI-XXXXXX

    const variantForSide = (side) => {
        const s = side;
        if (s === 'vorderseite' || s === 'rückseite' || s === 'Oberseite' || s === 'Innenseite') return PRODUCT_1;
        else if (s === 'beidseitig') return PRODUCT_2;
        else if (s === 'Lasergravur seitlich am Gehäuse' || s === 'Uhrengravur') return PRODUCT_3;
        else if (s === 'Beidseitig-Siegelring') return PRODUCT_4;
        else if (s === 'Ringgravur') return PRODUCT_5;
        else if (s === 'Rückseite/Vorderseite') return PRODUCT_6;
        return PRODUCT_1;
    };

    function getQuantityInput(form) {
        const root = getRoot();
        const inputs = [...root.querySelectorAll(qtyInputSelector)];
        if (!inputs.length) {
            return null;
        }

        if (form.id) {
            const byForm = inputs.find(i => i.getAttribute('form') === form.id);
            if (byForm) {
                return byForm;
            }
        }
        const inside = inputs.find(i => form.contains(i));
        if (inside) {
            return inside;
        }

        const c = getContainer();
        const scoped = c ? c.querySelectorAll('quantity-component input[type="number"][name="quantity"]') : [];
        const fallback = scoped[scoped.length - 1] || inputs[inputs.length - 1];
        return fallback;
    }
    const readMainQty = (form) => {
        const input = getQuantityInput(form);
        const n = parseInt((input && input.value) || '1', 10);
        return Number.isFinite(n) && n > 0 ? n : 1;
    };

    // --- add-on hidden inputs --------------------------------------------------
    function getOrInitItemsIndex(form) {
        if (form.dataset[FORM_IDX_DATA_KEY]) {
            const existingIndex = Number(form.dataset[FORM_IDX_DATA_KEY]);
            return existingIndex;
        }
        const existing = [...form.querySelectorAll('[name^="items["]')];
        const indices = existing
            .map(el => {
                const m = el.name.match(/^items\[(\d+)\]/);
                return m ? Number(m[1]) : null;
            })
            .filter(n => n !== null);
        const nextIndex = indices.length ? Math.max(...indices) + 1 : 1;
        form.dataset[FORM_IDX_DATA_KEY] = String(nextIndex);
        return nextIndex;
    }

    function ensureExtraInputs(form) {
        const idx = getOrInitItemsIndex(form);
        let idInput     = form.querySelector(`input[${DATA_FLAG}="id"]`);
        let qtyInput    = form.querySelector(`input[${DATA_FLAG}="qty"]`);
        let engraveProp = form.querySelector(`input[${DATA_FLAG}="engrave"]`);

        if (!idInput) {
            idInput = document.createElement('input');
            idInput.type = 'hidden';
            idInput.name = `items[${idx}][id]`;
            idInput.setAttribute(DATA_FLAG, 'id');
            form.appendChild(idInput);
        }
        if (!qtyInput) {
            qtyInput = document.createElement('input');
            qtyInput.type = 'hidden';
            qtyInput.name = `items[${idx}][quantity]`;
            qtyInput.setAttribute(DATA_FLAG, 'qty');
            form.appendChild(qtyInput);
        }
        if (!engraveProp) {
            engraveProp = document.createElement('input');
            engraveProp.type = 'hidden';
            engraveProp.name = `items[${idx}][properties][EngraveID]`;
            engraveProp.setAttribute(DATA_FLAG, 'engrave');
            form.appendChild(engraveProp);
        }
        return { idInput, qtyInput, engraveProp };
    }

    function syncQtyToExtra(form) {
        const qty = readMainQty(form);
        const q = form.querySelector(`input[${DATA_FLAG}="qty"]`);
        if (q && q.value !== String(qty)) {
            q.value = String(qty);
        } else {
        }
    }

    function updateExtraVariant(form) {
        const sideEl = getRoot().querySelector(sideSelector);
        const idInput = form.querySelector(`input[${DATA_FLAG}="id"]`);
        if (!idInput) {
            return;
        }
        const next = variantForSide(sideEl ? sideEl.value : '');
        if (idInput.value !== next) {
            idInput.value = next;
        } else {
        }
    }

    function ensureMainEngraveId(form, value) {
        let input = form.querySelector(`input[name="${MAIN_ENGRAVE_PROP}"]`);
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = MAIN_ENGRAVE_PROP;
            form.appendChild(input);
        }
        input.value = value;
    }

    // --- radio sync (kept minimal; no ID generation here anymore) --------------
    function syncFromRadio(radio) {
        const root = getRoot();
        const radios = root.querySelectorAll(radiosSelector);
        if (!radios.length) {
            return;
        }

        const form = getATCForm();
        if (!form) {
            return;
        }

        const isJa = radio.checked && String(radio.value).trim().toLowerCase() === 'ja';
        if (isJa) {
            // Make sure add-on inputs exist and are aligned with variant/qty
            ensureExtraInputs(form);
            updateExtraVariant(form);
            syncQtyToExtra(form);
            // Do NOT set EngraveID here; it's generated per submit click.
        } else {
            // Clean up on Nein
            form.querySelectorAll(`[${DATA_FLAG}]`).forEach(el => el.remove());
            delete form.dataset[FORM_IDX_DATA_KEY];
            const mainProp = form.querySelector(`input[name="${MAIN_ENGRAVE_PROP}"]`);
            if (mainProp) mainProp.remove();
        }
    }

    // --- attach ---------------------------------------------------------------
    function attach() {
        const root = getRoot();
        const form = getATCForm();
        if (!form) {
            return;
        }

        // Initial radio pass
        const initiallyChecked = root.querySelector(`${radiosSelector}:checked`);
        if (initiallyChecked) syncFromRadio(initiallyChecked);

        // Radio changes
        root.addEventListener('change', (e) => {
            const t = e.target;
            if (t && t.matches(radiosSelector)) {
                syncFromRadio(t);
            }
        });

        // Side changes keep add-on variant aligned
        root.addEventListener('change', (e) => {
            const t = e.target;
            if (!t || !t.matches(sideSelector)) return;
            const checked = root.querySelector(`${radiosSelector}:checked`);
            if (!checked || String(checked.value).trim().toLowerCase() !== 'ja') return;
            ensureExtraInputs(form);
            updateExtraVariant(form);
        });

        // Quantity changes keep add-on qty aligned
        const qtyInput = getQuantityInput(form);
        const qtyComp = qtyInput ? qtyInput.closest('quantity-component') : null;
        if (qtyComp) {
            const resync = () => {
                const checked = root.querySelector(`${radiosSelector}:checked`);
                if (!checked || String(checked.value).trim().toLowerCase() !== 'ja') return;
                syncQtyToExtra(form);
            };
            qtyComp.addEventListener('input', resync, true);
            qtyComp.addEventListener('change', resync, true);
            qtyComp.addEventListener('click', (e) => {
                const btn = e.target.closest?.('quantity-btn,[data-action]');
                if (btn) setTimeout(resync, 0);
            }, true);
        }

        // IMPORTANT: generate a new EngraveID on every Add to Cart click
        form.addEventListener('submit', (e) => {
            const checked = root.querySelector(`${radiosSelector}:checked`);
            const isJa = !!(checked && String(checked.value).trim().toLowerCase() === 'ja');
            if (!isJa) {
                return; // nothing special if engraving is off
            }

            // Ensure add-on inputs exist and are up-to-date
            const { idInput, qtyInput, engraveProp } = ensureExtraInputs(form);
            updateExtraVariant(form);
            syncQtyToExtra(form);
            // Generate fresh FEI-XXXXXX and apply to BOTH main and add-on
            const newId = makeEngraveId();
            ensureMainEngraveId(form, newId);
            engraveProp.value = newId;

            // allow normal submit to proceed (no preventDefault)
        }, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attach);
    } else {
        attach();
    }
})();

// Robust EngraveID group quantity sync for cart +/- and manual edits
(() => {
    // --- read EngraveID from a <cart-item> line --------------------------------
    function getEngraveId(cartItemEl) {
        const rows = cartItemEl.querySelectorAll('.cart-item__option.properties');
        for (const row of rows) {
            const first = row.firstElementChild;
            if (!first) continue;
            const label = (first.textContent || '').trim().replace(/:$/, '');
            if (label === 'EngraveID') {
                const valEl = first.nextElementSibling;
                if (valEl) return (valEl.textContent || '').trim();
            }
        }
        return null;
    }

    function getQtyInput(cartItemEl) {
        return cartItemEl.querySelector('quantity-component input[type="number"]') ||
            cartItemEl.querySelector('input[type="number"]');
    }

    // --- Shopify AJAX helpers ---------------------------------------------------
    async function fetchCart() {
        const res = await fetch('/cart.js', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
        });
        if (!res.ok) throw new Error('cart.js failed');
        return res.json();
    }

    // IMPORTANT: do these sequentially to avoid race conditions with the theme
    async function setLineQuantityByKeySequential(keys, quantity) {
        for (const key of keys) {
            const res = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: key, quantity })
            });
            if (!res.ok) {
                const t = await res.text();
                console.warn('[engrave-sync] change failed', key, res.status, t);
            }
        }
    }

    // Update any DOM inputs for that EngraveID to reflect the final qty
    function syncDomInputs(engraveId, quantity) {
        document.querySelectorAll('cart-item').forEach((ci) => {
            const id = getEngraveId(ci);
            if (id === engraveId) {
                const input = getQtyInput(ci);
                if (input && input.value !== String(quantity)) {
                    input.value = String(quantity);
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        });
    }

    // Debounce per EngraveID; do a second pass after re-render
    const timers = new Map(); // engraveId -> timeout

    function scheduleSync(engraveId, quantity, delay = 250) {
        if (timers.has(engraveId)) clearTimeout(timers.get(engraveId));
        const tid = setTimeout(() => doSync(engraveId, quantity).catch(console.error), delay);
        timers.set(engraveId, tid);
    }

    async function doSync(engraveId, quantity) {
        // Pass 1: update backend sequentially
        const cart = await fetchCart();
        const groupItems = cart.items.filter(it => (it.properties && it.properties.EngraveID === engraveId));
        const keys = groupItems.map(it => it.key);
        if (!keys.length) return;

        await setLineQuantityByKeySequential(keys, quantity);
        syncDomInputs(engraveId, quantity);

        // Pass 2 (post re-render): run again shortly after theme redraws
        setTimeout(async () => {
            try {
                const c2 = await fetchCart();
                const g2 = c2.items.filter(it => (it.properties && it.properties.EngraveID === engraveId));
                const needFix = g2.filter(it => it.quantity !== quantity).map(it => it.key);
                if (needFix.length) {
                    await setLineQuantityByKeySequential(needFix, quantity);
                    syncDomInputs(engraveId, quantity);
                }
            } catch (e) {
                console.warn('[engrave-sync] second pass failed', e);
            }
        }, 500);
    }

    // --- Event wiring -----------------------------------------------------------
    function handleQtyInputChange(e) {
        const t = e.target;
        if (!(t instanceof HTMLInputElement) || t.type !== 'number') return;

        const cartItem = t.closest('cart-item');
        if (!cartItem) return;

        const engraveId = getEngraveId(cartItem);
        if (!engraveId) return;

        const newQty = parseInt(t.value || '1', 10);
        if (!Number.isFinite(newQty) || newQty < 0) return;

        // Let the theme push its own change first, then sync the group
        scheduleSync(engraveId, newQty, 250);
    }

    function handlePlusMinusClick(e) {
        const btn = e.target.closest?.(
            '[data-action="plus"], [data-action="minus"], .cart-item-quantity__button, .quantity__btn'
        );
        if (!btn) return;

        const cartItem = btn.closest('cart-item');
        if (!cartItem) return;

        const engraveId = getEngraveId(cartItem);
        if (!engraveId) return;

        // Wait for the theme to apply the step and possibly start its AJAX
        setTimeout(() => {
            const input = getQtyInput(cartItem);
            if (!input) return;
            const newQty = parseInt(input.value || '1', 10);
            if (!Number.isFinite(newQty) || newQty < 0) return;
            scheduleSync(engraveId, newQty, 250);
        }, 80);
    }

    document.addEventListener('input', handleQtyInputChange, true);
    document.addEventListener('change', handleQtyInputChange, true);
    document.addEventListener('click', handlePlusMinusClick, true);
})();

// Remove BOTH items with the same EngraveID, then refresh cart via Section Rendering API
(() => {
    // --- read EngraveID from a <cart-item> ------------------------------------
    function getEngraveId(ci) {
        const rows = ci.querySelectorAll('.cart-item__option.properties');
        for (const row of rows) {
            const first = row.firstElementChild;
            if (!first) continue;
            const label = (first.textContent || '').trim().replace(/:$/, '');
            if (label === 'EngraveID') {
                const valEl = first.nextElementSibling;
                if (valEl) return (valEl.textContent || '').trim();
            }
        }
        return null;
    }

    // --- Shopify AJAX helpers ---------------------------------------------------
    async function fetchCart() {
        const res = await fetch('/cart.js', {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
        });
        if (!res.ok) throw new Error('cart.js failed');
        return res.json();
    }

    async function removeByKeySequential(keys) {
        for (const key of keys) {
            const r = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: key, quantity: 0 })
            });
            // don't throw on non-200; proceed to try to refresh UI anyway
        }
    }

    // --- Section Rendering API --------------------------------------------------
    function detectCartSectionIds() {
        const ids = new Set();

        // 1) Any element that advertises a section id and looks cart-related
        document.querySelectorAll('[data-section-id]').forEach(el => {
            const id = String(el.getAttribute('data-section-id') || '').trim();
            const type = String(el.getAttribute('data-section-type') || '').toLowerCase();
            if (!id) return;

            // Heuristics: cart drawer/page, items, bubbles, notifications
            if (
                /cart|drawer|items|bubble|notification|main-cart/i.test(id) ||
                /cart|drawer/.test(type)
            ) {
                ids.add(id);
            }
        });

        // 2) Common fallbacks used by many themes (Dawn & friends)
        [
            'main-cart-items',
            'cart-items',
            'cart-drawer',
            'cart-icon-bubble',
            'cart-live-region-text',
            'cart-notification'
        ].forEach(id => ids.add(id));

        return Array.from(ids);
    }

    async function refreshSections() {
        const ids = detectCartSectionIds();
        if (!ids.length) return;

        const url = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}?sections=${encodeURIComponent(ids.join(','))}`;
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('sections fetch failed');

        // Response is JSON: { "<section-id>": "<html>", ... }
        const data = await res.json();

        // Replace each section’s HTML in-place
        for (const id of Object.keys(data)) {
            const html = data[id];
            if (!html) continue;

            // Try by [data-section-id]
            const host = document.querySelector(`[data-section-id="${CSS.escape(id)}"]`);
            if (host) {
                // Replace the host's innerHTML (preserving the wrapper)
                host.innerHTML = html;
                continue;
            }

            // Try by id attribute (rare)
            const byId = document.getElementById(id);
            if (byId) {
                byId.innerHTML = html;
            }
        }

        // Fire theme-friendly events after replacement
        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.dispatchEvent(new CustomEvent('cart:updated'));
        window.dispatchEvent(new CustomEvent('cart:refresh'));
    }

    // Optimistic UI removal (so lines vanish instantly), then proper section refresh
    async function removeGroupAndRefresh(engraveId) {
        // 1) Snapshot keys for this group
        const cart = await fetchCart();
        const keys = cart.items
            .filter(it => it.properties && it.properties.EngraveID === engraveId)
            .map(it => it.key);

        if (!keys.length) return;

        // 2) Remove on backend
        await removeByKeySequential(keys);

        // 3) Optimistically remove matching DOM nodes
        document.querySelectorAll('cart-item').forEach(ci => {
            if (getEngraveId(ci) === engraveId) ci.remove();
        });

        // 4) Refresh sections (totals, bubble, drawer/page)
        try {
            await refreshSections();
        } catch (e) {
            // Last resort: soft reload if theme doesn't use sections we can target
            setTimeout(() => location.reload(), 300);
        }
    }

    // --- Click handler ----------------------------------------------------------
    const removingIds = new Set();

    function onRemoveClick(e) {
        const btn = e.target.closest?.(
            'cart-remove-button, [data-cart-remove], [data-remove], button[name="remove"], .cart-remove'
        );
        if (!btn) return;

        const cartItem = btn.closest?.('cart-item');
        if (!cartItem) return;

        const engraveId = getEngraveId(cartItem);
        if (!engraveId) return; // not a grouped line → let the theme handle it

        if (removingIds.has(engraveId)) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        removingIds.add(engraveId);

        removeGroupAndRefresh(engraveId)
            .catch(err => {
                console.error('[engrave-remove] failed', err);
                location.reload();
            })
            .finally(() => removingIds.delete(engraveId));
    }

    document.addEventListener('click', onRemoveClick, true);
})();

document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (event) {
        if (event.target && event.target.classList.contains('insert-symbol-btn')) {
            const symbol = event.target.getAttribute('data-symbol');

            try {
                const optionWrapper = event.target.closest('.cl-po--option');
                if (!optionWrapper) {
                    console.warn('No .cl-po--option wrapper found for symbol button');
                    return;
                }

                const textarea = optionWrapper.querySelector('textarea.cl-po--input');
                if (!textarea) {
                    console.warn('Textarea not found');
                    return;
                }

                // Save current selection
                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const text = textarea.value;

                // Insert the symbol
                textarea.value =
                    text.substring(0, start) +
                    symbol +
                    text.substring(end);

                // Restore cursor position after the inserted symbol
                const newCursorPos = start + symbol.length;
                textarea.selectionStart = textarea.selectionEnd = newCursorPos;

                // Focus the textarea
                textarea.focus();

                // Critical: Trigger both 'input' and 'change' events
                // Most frameworks/libraries (React, Vue, Angular, etc.) listen to 'input'
                // Native <textarea> change fires on blur, but dispatching it early helps
                textarea.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
                textarea.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));

            } catch (e) {
                console.warn("Error inserting symbol:", e);
            }
        }
    });
});


document.body.addEventListener('click', function(event) {
    if (event.target && event.target.classList.contains('font-select-btn')) {
        const font = event.target.getAttribute('data-font');
        const textarea = document.querySelector('textarea.cl-po--input');
        if (textarea) {
            textarea.style.fontFamily = font;
            textarea.focus();
        }
    }
});


